/**
 * Scripts
 */
import 'vite/modulepreload-polyfill'
import 'lazysizes'
import { startupTheme } from './js/theme'

// Import modules
import './js/tracking'
import './js/toggle'
import './js/fitText'
import './js/overlay'
import './js/sideNav'
import './js/video'
import './js/projectOverlay'
import './js/projectGallery'
import './js/loadMore'
import './js/cookieBanner'
import './js/scroll'
import './js/splitReveal'

import './sass/main.sass'

/**
 * Start Theme
 */
startupTheme()
